import React from 'react';
import Helmet from 'react-helmet';
import { BrowserRouter, Switch } from 'react-router-dom';
import { Box, makeStyles } from 'housecall-ui';
import CssBaseline from 'housecall-ui/dist/utils/CssBaseline';

import { AnonymousExperimentProvider } from '../../src/resources/amplitude/AnonymusProvider';
import { QueryClientProvider } from '../../src/resources/QueryClientProvider';
import { FormSkeleton } from '../components/FormSkeleton';

import { LeadFormThemeProvider } from './LeadFormThemeProvider';

type Props = {
  children: React.ReactNode;
};

const MAX_WIDTH = 534;

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: MAX_WIDTH,
  },
  innerContainer: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius * 2,
  },
}));

export const LeadFormProviders = ({ children }: Props) => {
  const { container, innerContainer } = useStyles();

  return (
    <>
      <Helmet>
        <title>Lead form</title>
      </Helmet>
      <CssBaseline />
      <LeadFormThemeProvider>
        <QueryClientProvider>
          <BrowserRouter>
            <Switch>
              <div className={container} id="lead-capture-content">
                <Box className={innerContainer}>
                  <AnonymousExperimentProvider proId="NoProID" email="" CustomLoader={FormSkeleton}>
                    {children}
                  </AnonymousExperimentProvider>
                </Box>
              </div>
            </Switch>
          </BrowserRouter>
        </QueryClientProvider>
      </LeadFormThemeProvider>
    </>
  );
};
